import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "../lib/api";

/* Logs IA → TravelerPulse funnel entries: any navigation carrying
   ?ref=indianairports* or ?utm_source=widget is beaconed to /india/ref-track.
   Renders nothing; mounted once inside the router. */
export default function RefTracker() {
  const loc = useLocation();

  useEffect(() => {
    const q = new URLSearchParams(loc.search);
    const ref = q.get("ref") || "";
    const utmSource = q.get("utm_source") || "";
    if (!ref.startsWith("indianairports") && utmSource !== "widget") return;
    api.post("/india/ref-track", {
      target: loc.pathname,
      source: q.get("src") || (utmSource === "widget" ? "partner-widget" : "unknown"),
      campaign: q.get("utm_campaign") || ref,
      medium: utmSource || "ref",
    }).catch(() => { /* beacon only */ });
  }, [loc.pathname, loc.search]);

  return null;
}
